<div *ngIf="visible">
  <div *ngIf="errorMessage" class="error-box error-message">
    <div class="error-icon">
      <fa-icon [icon]="['fas','exclamation-triangle']"></fa-icon>
    </div>
    <div class="message-text">
      {{errorMessage}}
    </div>
  </div>

  <a *ngIf="altLinkEnabled" [routerLink]="altLink" class="button">{{altLinkCaption}}</a>
  <button *ngIf="altButtonEnabled" type="button" [class]="'button ' + buttonClasses" (click)="altButtonAction.next()" [disabled]="busy">{{altButtonCaption}}</button>
  <button type="button" [class]="'button ' + buttonClasses" *ngIf="resetButtonEnabled" (click)="resetData()" [disabled]="(updateButtonState && disabled) || busy">Annuleren</button>
  <button type="submit" [class]="'button button-primary ' + buttonClasses" [disabled]="(updateButtonState && disabled) || busy" [class.success]="updateButtonState && success">
    <span *ngIf="!updateButtonState || !success">{{saveCaption}}</span>
    <span *ngIf="updateButtonState && success">
          <fa-icon class="success" [icon]="['fas', 'check']"></fa-icon>
    </span>
  </button>
</div>

<div class="busy" [class.visible]="busy">
  <ngx-loading [show]="true"></ngx-loading>
</div>
